export default {
    // URL: "https://socket.advice.uz",
    URL: "http://localhost:3003"
}
